import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import StructuredData from '@/components/base/StructuredData';
import Breadcrumb from '@/components/base/Breadcrumb';
import { siteInfo } from '@/mocks/navigation';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }
    formData.delete('company_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9q2finnahb7382ov520', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormError(serverMsg || '提交失败，请稍后再试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查您的连接后重试');
      setFormStatus('error');
    }
  };

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 澳门新葡京娱乐平台',
    description: '澳门新葡京娱乐平台成立于2011年，是澳门最具影响力的在线娱乐平台之一。了解我们的品牌故事、发展历程与信誉保障。',
    url: 'https://www.xinpujing.mo/about',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于我们 - 澳门新葡京娱乐平台',
    description: '了解澳门新葡京娱乐平台的品牌故事、发展历程、信誉认证与联系方式。',
    url: 'https://www.xinpujing.mo/about',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.xinpujing.mo/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  const milestones = [
    { year: '2011', title: '品牌创立', desc: '澳门新葡京娱乐平台正式成立，开启高品质娱乐服务之路' },
    { year: '2014', title: '移动端上线', desc: '推出首款移动端app，让玩家随时随地畅享游戏乐趣' },
    { year: '2017', title: '会员突破百万', desc: '注册会员突破100万，成为澳门最具影响力的在线娱乐平台之一' },
    { year: '2020', title: '技术全面升级', desc: '投入亿元级研发资金，完成平台架构全面升级，性能大幅提升' },
    { year: '2023', title: '国际化发展', desc: '拓展海外市场，服务范围覆盖东南亚及全球华人用户' },
    { year: '2026', title: '行业领军', desc: '荣获年度最佳在线娱乐品牌，注册会员突破500万' },
  ];

  const certifications = [
    { icon: 'ri-shield-check-line', title: '合法经营许可', desc: '持有澳门特别行政区政府颁发的合法博彩经营牌照' },
    { icon: 'ri-lock-line', title: '数据安全认证', desc: '通过ISO 27001信息安全管理体系国际认证' },
    { icon: 'ri-scales-line', title: '公平游戏认证', desc: '游戏系统通过GLI国际博彩实验室公平性检测认证' },
    { icon: 'ri-bank-line', title: '资金托管保障', desc: '玩家资金由持牌金融机构独立托管，与运营资金隔离' },
  ];

  return (
    <>
      <ScrollToTop />
      <StructuredData data={aboutPageSchema} />
      <StructuredData data={webPageSchema} />
      <StructuredData data={breadcrumbSchema} />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />
            <div className="px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                关于我们
              </h1>
              <p className="text-sm text-foreground-500">
                了解澳门新葡京娱乐平台的品牌故事与发展历程
              </p>
            </div>
          </div>
        </div>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
              <div className="flex-1">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                  品牌介绍
                </span>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                  {siteInfo.fullName}
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  澳门新葡京娱乐平台成立于2011年，是澳门最具影响力的在线娱乐平台之一。我们持有澳门特别行政区政府颁发的合法经营牌照，致力于为全球玩家提供安全、公平、优质的在线娱乐服务。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  平台汇聚了超过800款精品游戏，涵盖老虎机、桌面游戏、真人视讯、体育竞技等多个品类。我们与全球顶尖游戏开发商建立了长期合作关系，持续为玩家带来最新、最优质的游戏内容。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  经过十五年的持续发展，新葡京已累计服务超过500万注册会员。我们始终坚持"安全第一、公平至上、创新驱动"的核心理念，不断优化产品体验，提升服务质量，赢得了广大玩家的信赖与好评。
                </p>
              </div>
              <div className="w-full lg:w-[420px] shrink-0">
                <div className="rounded-xl overflow-hidden h-64 md:h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Luxurious%20Macau%20casino%20building%20exterior%20with%20golden%20warm%20illumination%20at%20dusk%2C%20grand%20architecture%20with%20elegant%20curves%2C%20premium%20lifestyle%20atmosphere%2C%20wide%20angle%20shot%2C%20professional%20architectural%20photography%2C%20dramatic%20sky%2C%20no%20people&width=800&height=600&seq=about-brand-macau&orientation=landscape"
                    alt="澳门新葡京娱乐平台"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                发展历程
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                品牌发展里程碑
              </h2>
            </div>

            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/60 md:-translate-x-px hidden md:block"></div>

              <div className="space-y-8">
                {milestones.map((item, index) => (
                  <div
                    key={item.year}
                    className={`flex flex-col md:flex-row gap-6 md:gap-10 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                      <div className="inline-block p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70">
                        <div className="text-2xl font-heading font-bold text-primary-600 mb-1">{item.year}</div>
                        <h3 className="text-base font-heading font-semibold text-foreground-950 mb-1">{item.title}</h3>
                        <p className="text-sm text-foreground-500">{item.desc}</p>
                      </div>
                    </div>
                    <div className="hidden md:flex w-8 shrink-0 items-start justify-center pt-6">
                      <div className="w-3 h-3 rounded-full bg-accent-500 ring-4 ring-accent-100"></div>
                    </div>
                    <div className="flex-1 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                信誉保障
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                权威认证与保障
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
                多重权威认证为您保驾护航，确保平台的安全、公平与可靠
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {certifications.map((item) => (
                <div
                  key={item.title}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center"
                >
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                联系我们
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                与我们取得联系
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                如有任何疑问或建议，欢迎通过以下方式联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
              <div className="space-y-5">
                <div className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-1">客服热线</h3>
                    <p className="text-sm text-foreground-500">{siteInfo.phone}</p>
                    <p className="text-xs text-foreground-400 mt-1">7×24小时全天候服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">{siteInfo.email}</p>
                    <p className="text-xs text-foreground-400 mt-1">工作日24小时内回复</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500">{siteInfo.address}</p>
                  </div>
                </div>
              </div>

              <div className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6">
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-4">在线留言</h3>
                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="space-y-4"
                >
                  <div>
                    <label htmlFor="about-name" className="block text-sm text-foreground-600 mb-1.5">姓名</label>
                    <input
                      id="about-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-sm text-foreground-600 mb-1.5">邮箱</label>
                    <input
                      id="about-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-sm text-foreground-600 mb-1.5">留言内容</label>
                    <textarea
                      id="about-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-3.5 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（最多500字）"
                    />
                  </div>
                  <div className="contact-honeypot">
                    <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <button
                    type="submit"
                    className="w-full px-5 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    提交留言
                  </button>

                  {formStatus === 'success' && (
                    <div className="p-3 rounded-lg bg-accent-100/50 text-accent-700 text-sm text-center">
                      留言已成功提交，我们会尽快与您联系！
                    </div>
                  )}
                  {formStatus === 'error' && (
                    <div className="p-3 rounded-lg bg-accent-100/50 text-accent-700 text-sm text-center">
                      {formError}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}